import QRImage from 'assets/qr.png';
import { useTranslation } from 'react-i18next';

export default function MedsiQRScan() {
  const { t } = useTranslation();

  return (
    <div className='w-full px-6 bg-white'>
      <div className='grid min-h-[calc(100vh-6rem)] max-w-2xl gap-6 mx-auto place-content-center'>
        <p className='text-lg font-medium text-center'>
          {t('scan_qr_code_message')}
        </p>
        <div className='mx-auto'>
          <img
            src={QRImage}
            alt={t('scan_qr')}
            className='object-fill h-60 aspect-square'
          />
        </div>
      </div>
    </div>
  );
}
